import React, {useRef, useMemo} from 'react'

const PaginationControl = ({visible, pageSizeOptions = [], pagination, table, manual, matchesCount}) => {

  const clientRowCount = manual ? undefined : table?.getFilteredRowModel().rows.length

  const paginationInfo = useMemo(() => {
      const pageIndex = (pagination.pageIndex || 0)
      const currentPage = pageIndex + 1
      const startRowNum = pageIndex * pagination.pageSize + 1
      const totalRows = manual
        ? matchesCount
        : clientRowCount
      const endRowNum = Math.min(totalRows, (pageIndex + 1) * pagination.pageSize)
      const pageCount = manual
        ? table?.getPageCount() || 0
        : pagination?.pageSize
          ? Math.ceil(totalRows / pagination.pageSize)
          : 0
      return {currentPage, startRowNum, totalRows, endRowNum, pageCount}
    }, [pagination.pageIndex, pagination.pageSize, manual, table, matchesCount, clientRowCount])

  const {currentPage, startRowNum, totalRows, endRowNum, pageCount} = paginationInfo

  const pageInputRef = useRef()
  
  const handlePageFocus = () => {
    // Select all text in the input
    pageInputRef.current.select()
  }

  const options = useMemo(() => {
    return pageSizeOptions.map(num => {
      return <option value={num} key={num}>{num} rows</option>
    })
  },[pageSizeOptions])

  return visible ? (
    <div className="-pagination">
      <div className="-previous">
        <button
          className="-btn"
          onClick={() => table?.previousPage()}
          disabled={!table?.getCanPreviousPage()}
        >
          Previous
        </button>
      </div>
      <div className="-center">
        {
          totalRows > 0
            ? (
            <>
              <span className="-pageInfo">
                Page
                <div className="-pageJump">
                  <input
                    aria-label={'page num'}
                    ref={pageInputRef}
                    onFocus={handlePageFocus}
                    type="number"
                    style={{ width: '4em' }}
                    value={currentPage}
                    onChange={e => {
                      const page = e.target.value ? Number(e.target.value) - 1 : 0
                      table?.setPageIndex(page)
                    }}
                    className="border p-1 rounded w-16"
                  />
                </div>
                of
                <span className="-totalPages">{pageCount}</span>
              </span>
              <span className="-rowInfo">
                {'Showing '}
                <span className="-rowMin">{startRowNum}</span>
                {' - '}
                <span className="-rowMax">{endRowNum}</span>
                {' of '}
                <span className="-rowCount">{totalRows}</span>
                {' rows'}
              </span>
            </>
              )
            : (
            <span>There are no rows</span>
              )
        }
        <span className="select-wrap -pageSizeOptions">
          <select
            aria-label="page size selector"
            value={pagination.pageSize}
            onChange={e => {
              table?.setPageSize(Number(e.target.value))
            }}
          >
            {options}
          </select>
        </span>
      </div>
      <div className="-next">
        <button
          className="-btn"
          onClick={() => table?.nextPage()}
          disabled={!table?.getCanNextPage()}
        >
          Next
        </button>
      </div>
    </div>
  ) : null
}

export default PaginationControl